var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teste"},[_c('h1',[_vm._v("This is an about page")]),_c('download-excel',{staticClass:"btn btn-default",attrs:{"data":_vm.json_dados,"fields":_vm.json_campos,"worksheet":"Planilha de Trabalho","name":"meu_arquivo.xls"}},[_vm._v(" Download Excel (you can customize this with html code!) ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }